import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "liga-float-bar playlist-float-bar" }
const _hoisted_2 = {
  key: 0,
  class: "playlist-hero"
}
const _hoisted_3 = { class: "playlist-hero__inner" }
const _hoisted_4 = { class: "playlist-hero__text" }
const _hoisted_5 = { class: "playlist-hero__name" }
const _hoisted_6 = {
  key: 0,
  class: "playlist-hero__program"
}
const _hoisted_7 = { class: "playlist-hero__chips" }
const _hoisted_8 = { class: "playlist-chip" }
const _hoisted_9 = { class: "playlist-chip" }
const _hoisted_10 = {
  key: 0,
  class: "playlist-chip playlist-chip--success"
}
const _hoisted_11 = { class: "playlist-hero__actions" }
const _hoisted_12 = { class: "download-button" }
const _hoisted_13 = { class: "column-buttons" }
const _hoisted_14 = { class: "column-buttons" }
const _hoisted_15 = { class: "track-number" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "track-info" }
const _hoisted_18 = { class: "track-name" }
const _hoisted_19 = { class: "track-duration" }
const _hoisted_20 = { class: "track-actions" }
const _hoisted_21 = { class: "play-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background playlist-view-page",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, {
            class: "playlist-container bg-transparent",
            "scroll-y": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, {
                mode: "md",
                class: "ion-no-border events-page-header liga-float-header playlist-view-header"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, { class: "playlist-view-toolbar" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", {
                          class: "liga-float-spacer",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "liga-float-title-pill" }, [
                          _createElementVNode("span", { class: "liga-float-title-text" }, "Микс")
                        ], -1)),
                        _withDirectives(_createElementVNode("button", {
                          type: "button",
                          class: "liga-float-circle playlist-close-circle",
                          "aria-label": "Закрыть",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePlaylist()))
                        }, [
                          _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                        ], 512), [
                          [_vShow, !_ctx.downloadProgressBar.downloading]
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, {
                class: "playlist-content",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  (_ctx.selectedPlaylist.name)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", {
                          class: "playlist-hero__glow",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.selectedPlaylist.name), 1),
                            (_ctx.selectedPlaylist.programName)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.selectedPlaylist.programName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", _hoisted_8, [
                                _createVNode(_component_ion_icon, { icon: _ctx.musicalNotesOutline }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.playlistTrackCount) + " " + _toDisplayString(_ctx.trackCountLabel), 1)
                              ]),
                              _createElementVNode("span", _hoisted_9, [
                                _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.mediaUtils.formatTime(
                                        _ctx.mediaUtils.getTotalPlaylistDuration(_ctx.selectedPlaylist.tracks)
                                    )), 1)
                              ]),
                              (_ctx.selectedPlaylist.offline)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.checkmarkCircle }, null, 8, ["icon"]),
                                    _cache[8] || (_cache[8] = _createTextVNode(" Оффлайн ", -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            size: "small",
                            class: "hero-action-btn",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goEditPlaylist()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.createOutline
                              }, null, 8, ["icon"]),
                              _cache[9] || (_cache[9] = _createTextVNode(" Изменить ", -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            size: "small",
                            class: "hero-action-btn hero-action-btn--danger",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeletePlaylist()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                icon: _ctx.trashOutline
                              }, null, 8, ["icon"]),
                              _cache[10] || (_cache[10] = _createTextVNode(" Удалить ", -1))
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, !_ctx.selectedPlaylist.isRelease && !_ctx.downloadProgressBar.downloading]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "playlist-header-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadPlaylist(_ctx.selectedPlaylist)))
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Загрузить оффлайн", -1)
                      ]))]),
                      _: 1
                    }, 512), [
                      [_vShow, 
                        !_ctx.selectedPlaylist.offline &&
                        !_ctx.downloadProgressBar.downloading &&
                        _ctx.globalContext.isMobile
                    ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        class: "playlist-header-button",
                        disabled: true
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("Доступно оффлайн", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        class: "playlist-header-button remove-download-button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeDownloadedPlaylist(_ctx.selectedPlaylist)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: _ctx.trashOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, 
                        _ctx.selectedPlaylist.offline && !_ctx.downloadProgressBar.downloading
                    ]
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "playlist-header-button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.stopDownload()))
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("Отмена", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_ion_text, { class: "playlist-header-button ion-text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.downloadProgressBar.downloaded) + " Mb", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_text, { class: "playlist-header-button ion-text-center" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("Не закрывайте окно до завершения загрузки", -1)
                      ]))]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.downloadProgressBar.downloading]
                  ]),
                  _withDirectives(_createVNode(_component_ion_progress_bar, {
                    value: 
                    _ctx.downloadProgressBar.currentValue /
                    _ctx.downloadProgressBar.maxValue
                    ,
                    class: "download-progress-bar"
                  }, null, 8, ["value"]), [
                    [_vShow, _ctx.downloadProgressBar.downloading]
                  ]),
                  _createVNode(_component_ion_content, {
                    forceOverscroll: true,
                    class: "playlist-tracks-scroll"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPlaylist.tracks, (track, idx) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: idx,
                          onClick: ($event: any) => (_ctx.selectTrack(idx)),
                          class: _normalizeClass(["track-item", { 'playing': _ctx.isTrackRowActive(idx), 'track-item--locked': _ctx.isTrackLocked(track) }])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              (_ctx.isTrackLocked(track))
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    icon: _ctx.lockClosedOutline,
                                    class: "track-lock-icon"
                                  }, null, 8, ["icon"]))
                                : (!_ctx.isTrackRowActive(idx))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(idx + 1), 1))
                                  : (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 2,
                                      icon: _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                                      class: "playing-icon"
                                    }, null, 8, ["icon"]))
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.mediaUtils.getTrackName(track)), 1),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.mediaUtils.formatTime(track.duration)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                (!_ctx.isTrackLocked(track))
                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 0,
                                      icon: _ctx.isTrackRowActive(idx) && _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                                      class: "play-icon"
                                    }, null, 8, ["icon"]))
                                  : (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 1,
                                      icon: _ctx.lockClosedOutline,
                                      class: "play-icon play-icon--locked"
                                    }, null, 8, ["icon"]))
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick", "class"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}